import logFactory from 'c9-js-log-client';

let logger: ReturnType<typeof logFactory> | undefined;
let formPath: string = 'Unknown Form Path';
let formTitle: string = 'Unknown Form Title';

export const setLogger = (logClient: typeof logger) => {
    logger = logClient;
};

export const setFormDetails = (title: string, path: string) => {
    formTitle = title;
    formPath = path;
};

export const logError = (message: string) => {
    console.error(message);
    if (logger) {
        return logger.error(`Error in form ${formTitle} (${formPath})
        ${message}`);
    }
};

export const log = (...args: any) => {
    args.forEach((arg: any) => {
        switch (typeof arg) {
            case 'string':
            case 'number':
                logInfo(String(arg));
                break;
            case 'object':
                logInfo(JSON.stringify(arg));
                break;
            default:
                console.error(typeof arg);
                break;
        }
    });
};

export const logInfo = (message: string) => {
    return logger?.info(message);
};
